export default __webpack_public_path__ + "static/media/klaus_m.d8b4ba63.jpg";